var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goback"},[_c('button',{staticClass:"back",on:{"click":_vm.goback}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"back-right"},[_c('button',{staticClass:"share",on:{"click":_vm.home}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }